import DataTable from 'react-data-table-component';
import { translate } from 'react-switch-lang';

const CountryColumns = (props) => {
  const activityColumns: any = [
    {
      name: props.t('commune_url'),
      selector: (row) => row.name,
      sortable: true,
      center: true,
    },
    // {
    //   name: props.t('status),
    //   selector: row => row.status,
    //   sortable: false,
    //   center: true,
    // },
    {
      id: 'Action',
      name: props.t('actions'),
      selector: (row) => row.action,
      sortable: false,
      center: true,
    },
  ];
  return <DataTable columns={activityColumns} data={props.data} />;
};
export default translate(CountryColumns);
